export enum FormGroupNames {
  GENERAL = 'general',
  OBJECTIFS = 'objectifs',
  RESSOURCES = 'ressources',
  CERTIFICATIONS = 'certifications',
  FORMATIONS_REGLEMENTAIRES = 'formationsReglementaires',
  COMPAGNONNAGE = 'compagnonnage',
  METIER = 'metier',
  SCIENCES_ET_CULTURE = 'sciencesEtCulture',
  LIVRABLES = 'livrables',
  INFORMATIONS_PRATIQUES = 'informationsPratiques',
  APTITUDES = 'aptitudes',
  APTITUDE_PRINCIPALE = 'aptitudePrincipale',
  DETAILS = 'details',
  CONTRAT = 'contrat',
}

export enum FormControlNames {
  NOM = 'nom',
  NOMS = 'noms',
  DUREE = 'duree',
  CONNAISSANCES = 'connaissances',
  DOCUMENTATIONS = 'documentations',
  MATERIELS = 'materiels',
  HABILETES = 'habiletes',
  APTITUDE = 'aptitude',
  APTITUDES = 'aptitudes',
  APTITUDES_EVALUEES = 'aptitudesEvaluee',
  APTITUDES_SECONDAIRES = 'aptitudesSecondaires',
  INTERRELATIONS = 'interrelations',
  PRODUCTIONS = 'productions',
  FAMILLES_LIVRABLES = 'famillesLivrables',
  CODE = 'code',
  TYPES_CONTRAT = 'typesContrat',
  TYPE = 'type',
  MODALITE = 'modalite',
  MODALITES = 'modalites',
  CONTEXTE = 'contexte',
  CERTIFICATION = 'certification',
  NOM_FORMATIONS_REGLEMENTAIRES = 'nomFormationReglementaires',
  NIVEAU_CEC = 'niveauCec',
  COMPETENCES_COMPAGNONNIQUES = 'competencesCompagnonniques',
  SECTEURS_ACTIVITE = 'secteursActivite',
  EMPLOIS_POSSIBLES = 'emploisPossibles',
  COMPETENCES_TRANSVERSES = 'competencesTransverses',
  SAVOIRS_SCIENTIFIQUES_CULTUREL = 'savoirsScientifiquesCulturel',
  ACTIVITES = 'activites',
  ETAT = 'etat',
  EST_PROGRAMMEE = 'estProgrammee',
  EST_EVALUEE = 'estEvaluee',
  A_CHANGEMENT_VILLE = 'aChangementVille',
  A_CURSUS_INTERNATIONAL = 'aCursusInternational',
  EST_CERTIFIANTE = 'estCertifiante',
  TITRE = 'titre',
  LIEU = 'lieu',
  LIEUX = 'lieux',
  DESCRIPTION = 'description',
  ID_REFERENTIEL = 'idReferentiel',
  DATE_CREATION = 'date_creation',
  REFERENTIEL = 'referentiel',
  TECHNIQUES_ANIMATION = 'techniquesAnimation',
  SUPPORTS = 'supports',
  LIVRABLES = 'livrables',
  SOUS_CARACTERISTIQUES = 'sousCaracteristiques',
  REGION = 'region',
  INSTITUT = 'institut',
  METIER = 'metier',
  PUBLICS_CIBLES = 'publicsCibles',
  AUTRE_TYPE = 'autreType',
  CODE_ETAPE = 'codeEtape',
  EST_OUVERTE = 'EstOuverte',
  EST_À_LA_CARTE = 'estALaCarte',
  GROUPES = 'groupes',
  ANCIEN_CODE = 'ancienCode',
  REPARTITIONS_ANNEE = 'repartitionsAnnee',
  NOMBRE_MOIS = 'nombreMois',
  NOMBRE_SEMAINES = 'nombreSemaines',
  TRIGRAMMES_TYPE = 'trigrammesType',
  OBJECTIF = 'objectif',
}
